const data = [{
  Year: 2002,
  Football: 13.61807346,
  "Men's basketball": 7.94622678,
  'Non-program specific': 17.9289774,
  "Other men's sports": 4.56750522,
  "Other women's sports": 6.5982453,
  "Women's basketball": 1.80200316,
}, {
  Year: 2003,
  Football: 17.9341636,
  "Men's basketball": 9.0060424,
  'Non-program specific': 19.5647067,
  "Other men's sports": 4.6130792,
  "Other women's sports": 5.8765039,
  "Women's basketball": 1.8830917,
}, {
  Year: 2004,
  Football: 20.9928543,
  "Men's basketball": 10.495386,
  'Non-program specific': 19.6313502,
  "Other men's sports": 5.67470805,
  "Other women's sports": 6.7081443,
  "Women's basketball": 1.83519765,
}, {
  Year: 2005,
  Football: 27.75202885,
  "Men's basketball": 9.73834099,
  'Non-program specific': 18.9941843,
  "Other men's sports": 6.78845069,
  "Other women's sports": 7.80379236,
  "Women's basketball": 1.83430037,
}, {
  Year: 2006,
  Football: 28.4839093,
  "Men's basketball": 9.54804312,
  'Non-program specific': 19.08066314,
  "Other men's sports": 6.53804998,
  "Other women's sports": 8.78493924,
  "Women's basketball": 2.1688359,
}, {
  Year: 2007,
  Football: 39.1449765,
  "Men's basketball": 9.27669,
  'Non-program specific': 22.1159685,
  "Other men's sports": 8.358477,
  "Other women's sports": 10.2544905,
  "Women's basketball": 3.0270135,
}, {
  Year: 2008,
  Football: 39.94079518,
  "Men's basketball": 8.75792632,
  'Non-program specific': 26.19466564,
  "Other men's sports": 6.37218582,
  "Other women's sports": 8.09244007,
  "Women's basketball": 2.62824848,
}, {
  Year: 2009,
  Football: 40.25326005,
  "Men's basketball": 8.40016465,
  'Non-program specific': 39.90970575,
  "Other men's sports": 6.9066951,
  "Other women's sports": 6.04548065,
  "Women's basketball": 1.65159205,
}, {
  Year: 2010,
  Football: 34.94012522,
  "Men's basketball": 9.96310887,
  'Non-program specific': 32.66454906,
  "Other men's sports": 7.02320905,
  "Other women's sports": 11.2575995961,
  "Women's basketball": 3.1228769,
}, {
  Year: 2011,
  Football: 33.57473622,
  "Men's basketball": 8.85665508,
  'Non-program specific': 35.34408942,
  "Other men's sports": 6.90337962,
  "Other women's sports": 4.48735842,
  "Women's basketball": 0.86919438,
}, {
  Year: 2012,
  Football: 35.4582342416,
  "Men's basketball": 10.8864572936,
  'Non-program specific': 14.71443466,
  "Other men's sports": 12.8236105712,
  "Other women's sports": 14.9654343152,
  "Women's basketball": 3.881261228,
}, {
  Year: 2013,
  Football: 50.46497218,
  "Men's basketball": 12.72054362,
  'Non-program specific': 42.38781532,
  "Other men's sports": 10.7974185,
  "Other women's sports": 4.7598609,
  "Women's basketball": 1.90165698,
}, {
  Year: 2014,
  Football: 43.57754824,
  "Men's basketball": 12.65245684,
  'Non-program specific': 47.46599897,
  "Other men's sports": 8.70156758,
  "Other women's sports": 4.25483939,
  "Women's basketball": 1.590995,
}, {
  Year: 2015,
  Football: 60.10782516,
  "Men's basketball": 12.55197067,
  'Non-program specific': 31.17780481,
  "Other men's sports": 8.32050037,
  "Other women's sports": 3.48245029,
  "Women's basketball": 1.32566105,
}, {
  Year: 2016,
  Football: 56.4680584,
  "Men's basketball": 12.4084974,
  'Non-program specific': 31.2850941,
  "Other men's sports": 8.4698835,
  "Other women's sports": 2.8147457,
  "Women's basketball": 0.696488,
}, {
  Year: 2017,
  Football: 57.98533632,
  "Men's basketball": 13.89431424,
  'Non-program specific': 37.33961472,
  "Other men's sports": 9.73073408,
  "Other women's sports": 1.96658048,
  "Women's basketball": 0.6312,
}, {
  Year: 2018,
  Football: 43.89734044,
  "Men's basketball": 10.91502932,
  'Non-program specific': 53.01874696,
  "Other men's sports": 9.23111676,
  "Other women's sports": 1.94284068,
  "Women's basketball": 0.63237396,
}, {
  Year: 2019,
  Football: 46.52023846,
  "Men's basketball": 10.4309634,
  'Non-program specific': 44.82326238,
  "Other men's sports": 8.06344848,
  "Other women's sports": 2.45885876,
  "Women's basketball": 0.7482443,
}, {
  Year: 2020,
  Football: 47.29085713,
  "Men's basketball": 9.71506459,
  'Non-program specific': 66.26541768,
  "Other men's sports": 7.58970443,
  "Other women's sports": 2.1873533,
  "Women's basketball": 0.62804566,
}, {
  Year: 2021,
  Football: 26.8361217,
  "Men's basketball": 5.6841372,
  'Non-program specific': 64.26249565,
  "Other men's sports": 9.49738655,
  "Other women's sports": 1.89208005,
  "Women's basketball": 0.44627015,
}, {
  Year: 2022,
  Football: 47.24157375,
  "Men's basketball": 9.0497925,
  'Non-program specific': 60.1402641,
  "Other men's sports": 7.08900045,
  "Other women's sports": 2.481045,
  "Women's basketball": 0.50178765,
}, {
  Year: 2023,
  Football: 38.7655794,
  "Men's basketball": 7.69629474,
  'Non-program specific': 74.53705692,
  "Other men's sports": 7.91509902,
  "Other women's sports": 2.51611866,
  "Women's basketball": 0.62850768,
}];

export default data;
